module.exports = __webpack_public_path__ + "img/belgium.bd28077b.svg";